module.exports = __webpack_public_path__ + "img/ondelivery.66915fc6.svg";